/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ChargeCalcResultDto {

    /**
     * 料金算定年月
     */
    chargeAcalcYmt?: string;
    /**
     * 使用量実績課金接続コード
     */
    kakinSetzokDiv?: string;
    /**
     * サービス種別コード
     */
    srvClsfyCode?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * 商品コード
     */
    goodsCode?: string;
    /**
     * 料金計算定義料金コード
     */
    chargeCode?: string;
    /**
     * 合計項目種別
     */
    sumDivCode?: string;
    /**
     * 料金算定期間開始日付
     */
    calcStartYmd?: string;
    /**
     * 料金算定期間終了日付
     */
    calcEndYmd?: string;
    /**
     * 算定期間日数
     */
    dailyPeriodDayCount?: string;
    /**
     * 内訳金額
     */
    detailAmount?: string;
    /**
     * 確定情報１
     */
    fixedInfo1?: string;
    /**
     * 確定情報２
     */
    fixedInfo2?: string;
    /**
     * 確定情報３
     */
    fixedInfo3?: string;
    /**
     * 確定情報４
     */
    fixedInfo4?: string;
    /**
     * 確定情報５
     */
    fixedInfo5?: string;
    /**
     * 確定情報６
     */
    fixedInfo6?: string;
    /**
     * 確定情報７
     */
    fixedInfo7?: string;
    /**
     * 確定情報８
     */
    fixedInfo8?: string;
    /**
     * 確定情報９
     */
    fixedInfo9?: string;
    /**
     * 確定情報１０
     */
    fixedInfo10?: string;
    /**
     * 確定情報１１
     */
    fixedInfo11?: string;
    /**
     * 確定情報１２
     */
    fixedInfo12?: string;
    /**
     * 確定情報１３
     */
    fixedInfo13?: string;
    /**
     * 確定情報１４
     */
    fixedInfo14?: string;
    /**
     * 確定情報１５
     */
    fixedInfo15?: string;
    /**
     * 確定情報１６
     */
    fixedInfo16?: string;
    /**
     * 確定情報１７
     */
    fixedInfo17?: string;
    /**
     * 確定情報１８
     */
    fixedInfo18?: string;
    /**
     * 確定情報１９
     */
    fixedInfo19?: string;
    /**
     * 確定情報２０
     */
    fixedInfo20?: string;
}

